import classNames from 'classnames';
import { FormattedDateParts } from 'react-intl';
import styled from 'styled-components';

import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { BrandS, LabelS, LabelXS } from '@sorare/core/src/atoms/typography';
import { tabletAndAbove } from '@sorare/core/src/style/mediaQuery';

const FullWidthHorizontal = styled(Horizontal)`
  width: 100%;
`;

const Date = styled(Horizontal).attrs({ gap: 0.5 })`
  border-radius: var(--unit);
  flex-shrink: 0;
  background-color: var(--c-nd-100-opaque);
  padding: var(--half-unit) var(--unit) var(--half-unit) var(--half-unit);
  &.sticky {
    position: sticky;
    top: calc(var(--current-stack-height) + calc(var(--unit) * 10));
  }
  @container ${tabletAndAbove} {
    flex-direction: column;
    align-items: stretch;
    justify-content: stretch;
    width: calc(var(--unit) * 8);
    border-radius: var(--unit);
    padding: 0 0 var(--half-unit) 0;
    &.sticky {
      top: calc(var(--current-stack-height) + var(--double-unit));
    }
  }

  .month {
    background-color: var(--c-nd-50);
    border-radius: 6px;
    margin: 2px;
    padding: var(--half-unit);
    @container ${tabletAndAbove} {
      padding: 0;
      border-radius: 6px 6px 2px 2px;
    }
  }
`;

const StyledBrandS = styled(BrandS)`
  @container ${tabletAndAbove} {
    font: var(--t-brand-m);
  }
`;

type Props = {
  className?: string;
  date: Date;
  sticky?: boolean;
};

export const Calendar = ({ date, sticky, className }: Props) => {
  return (
    <Date className={classNames(className, { sticky })}>
      <FormattedDateParts
        value={date}
        month="long"
        day="2-digit"
        weekday="short"
      >
        {parts => {
          const partValue = (type: Intl.DateTimeFormatPartTypes) =>
            parts.find(part => part.type === type)?.value;

          return (
            <>
              <FullWidthHorizontal center className="month">
                <LabelXS uppercase bold>
                  {partValue('month')}
                </LabelXS>
              </FullWidthHorizontal>
              <StyledBrandS color="var(--c-white)" className="text-center">
                {partValue('day')}
              </StyledBrandS>
              <LabelS className="text-center" color="var(--c-nd-600)" uppercase>
                {partValue('weekday')}
              </LabelS>
            </>
          );
        }}
      </FormattedDateParts>
    </Date>
  );
};
